<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
body{
	margin: 0;
	width: 100%;
	background-color: #F9FAFB;
	/* background-image: url('./assets/oneRizeLive 01_slices/组 8.png'); */
	/* height: calc(100vh - 60px); /* 浏览器高度减去60px */ 
}
::v-deep .router-link-active {
    color: red; /* 或者其他颜色 */
}
</style>

